import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.EXECUTIONS,
  nodeType: Generator.NODETYPE.POST2PHASES
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/executions/post.js